import _ from 'classnames';
import React from 'react';
import { Skeleton } from "../../../skeleton/Skeleton.js";
import styles from "./DataGridCell.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function DataGridCellSkeleton({
  isFirst,
  isLast,
  isLastRow
}) {
  return /*#__PURE__*/_jsx("div", {
    className: _(styles.dataGridCell, {
      [styles.isFirst]: isFirst,
      [styles.isLast]: isLast,
      [styles.isLastRow]: isLastRow
    }),
    children: /*#__PURE__*/_jsx(Skeleton, {
      maxWidth: 300,
      variant: "rect",
      height: 14
    })
  });
}